// Login
export const LOGIN = 'auth/LOGIN';
export const LOGIN_PROCESS = 'auth/LOGIN_PROCESS';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';

export const AUTOLOGIN = 'auth/AUTOLOGIN';

// Register
export const REGISTER = 'auth/REGISTER';
export const REGISTER_PROCESS = 'auth/REGISTER_PROCESS';
export const REGISTER_SUCCESS = 'auth/REGISTER_SUCCESS';
export const REGISTER_ERROR = 'auth/REGISTER_ERROR';

// Logout
export const LOGOUT = 'auth/LOGOUT';

// FETCH USER
export const FETCH_USER = 'auth/FETCH_USER';
export const FETCH_USER_PROCESS = 'auth/FETCH_USER_PROCESS';
export const FETCH_USER_ERROR = 'auth/FETCH_USER_ERROR';
export const FETCH_USER_SUCCESS = 'auth/FETCH_USER_SUCCESS';

// PATCH USER
export const PATCH_USER = 'auth/PATCH_USER';
export const PATCH_USER_PROCESS = 'auth/PATCH_USER_PROCESS';
export const PATCH_USER_ERROR = 'auth/PATCH_USER_ERROR';
export const PATCH_USER_SUCCESS = 'auth/PATCH_USER_SUCCESS';

// RESET PASSWORD
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const RESET_PASSWORD_PROCESS = 'auth/RESET_PASSWORD_PROCESS';
export const RESET_PASSWORD_ERROR = 'auth/RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_SUCCESS = 'auth/RESET_PASSWORD_SUCCESS';

// FORGOT PASSWORD
export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_PROCESS = 'auth/FORGOT_PASSWORD_PROCESS';
export const FORGOT_PASSWORD_ERROR = 'auth/FORGOT_PASSWORD_ERROR';
export const FORGOT_PASSWORD_SUCCESS = 'auth/FORGOT_PASSWORD_SUCCESS';

// REINIT PASSWORD
export const REINIT_PASSWORD = 'auth/REINIT_PASSWORD';
export const REINIT_PASSWORD_PROCESS = 'auth/REINIT_PASSWORD_PROCESS';
export const REINIT_PASSWORD_ERROR = 'auth/REINIT_PASSWORD_ERROR';
export const REINIT_PASSWORD_SUCCESS = 'auth/REINIT_PASSWORD_SUCCESS';

// REFRESH TOKEN
export const REFRESH_TOKEN = 'auth/REFRESH_TOKEN';
